import { render } from "./SpecialSkills.vue?vue&type=template&id=404395a4&scoped=true"
import script from "./SpecialSkills.vue?vue&type=script&lang=js"
export * from "./SpecialSkills.vue?vue&type=script&lang=js"

import "./SpecialSkills.vue?vue&type=style&index=0&id=404395a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404395a4"]])

export default __exports__